<template>
    <base-layout>
        <main class="settings" slot="main">
            <h1>Settings</h1>
            
            <nav class="settings-nav">
                <ul>
                    <li>
                        <router-link to="/settings/profile">
                            Profile
                        </router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/settings/account">
                            Account
                        </router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/settings/campaigns">
                            Campaigns
                        </router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/settings/fields">
                            Fields
                        </router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/settings/tags">
                            Tags
                        </router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/settings/filters">
                            Filters
                        </router-link>
                    </li>
                    <li v-if="isAdmin">
                        <router-link to="/settings/models">
                            Models
                        </router-link>
                    </li>
                </ul>
            </nav>
            
            <slot name="main"></slot>
            <slot name="footer"></slot>
        </main>
        <slot name="modals" slot="modals"></slot>
    </base-layout>
</template>

<script>
 import BaseLayout from './BaseLayout';
 var _ = require('lodash');

 
export default {
     components: {
         BaseLayout
     },
     data () {
         return {
     }},
     computed: {
         isAdmin: function () {
             return this.$store.state.user.role == 'superuser';
         }
     },
     created () {
     },
     methods: {
     }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 nav.settings-nav a.router-link-exact-active {
     text-decoration: none;
     color: #ff7a7c;
     font-weight: 700;
 }
</style>



// WEBPACK FOOTER //
// AdminLayout.vue?67637d00